const env: string = 'prod';

export function getWorkflowURI() {
  return process.env.APP_WORKFLOW_URI;
}
export function getKisaanBaseURL() {
  return process.env.APP_KISAN_URI;
}
export function getIamURI() {
  return process.env.APP_IAM_URI;
}
export function getHashKey() {
  return process.env.APP_SMS_HASH;
}

export function isAzureKeyForLogin() {
  const hashKey = 'identity';
  return hashKey;
}
const paths = {
  login: () => `${getIamURI()}/api/v1/auth/send/otp`,
  getTruecallerData: () => `${getIamURI()}/api/v1/auth/social-login/truecaller`,
  onboardTraders: () => `${getIamURI()}/api/v1/auth/signin/otp`,
  OTPAuth: () => `${getKisaanBaseURL()}/kisaan/auth`,
  getExchangeToken: (userid) => `${getKisaanBaseURL()}/kisaan/auth/exchangeToken/${userid}`,
  getProfileUser: (userId, realmId) => `${getKisaanBaseURL()}/kisaan/user/${userId}/${realmId}`, 
  editProfileSubmit: (userId, realmId) => `${getKisaanBaseURL()}/kisaan/user/${userId}/${realmId}`,
  pincodeAddress: (realmId, userId) =>
    `${getWorkflowURI()}/workflow-engine/${realmId}/${userId}/v1/execution/service/runWithNoAuth/pincode-address`,
  uplodFile: (userId) => `${getKisaanBaseURL()}/kisaan/user/${userId}`,
  updateFollowStatus: (type: string) => `${getKisaanBaseURL()}/kisaan/user/associations/${type}`,
  getCategoryList: () => `${getKisaanBaseURL()}/kisaan/crop/p/list`,
  getCropsbyCategoryList: (cropId) =>
    `${getKisaanBaseURL()}/kisaan/crop/p/category/list?cropId=${cropId}`,
  createUserPreference: (realmId, userId) =>
    `${getKisaanBaseURL()}/kisaan/crop/preference/${userId}/${realmId}/create`,

  getAnimalsList: () => `${getKisaanBaseURL()}/kisaan/crop/p/registry-list?name=AnimalHusbandry`,
  updateUserPreference: (realmId, userId) =>
    `${getKisaanBaseURL()}/kisaan/crop/preference/${userId}/${realmId}/update`,

  getCropsPreference: (userId, realmId) =>
    `${getKisaanBaseURL()}/kisaan/crop/user/preferences?userId=${userId}&realmId=${realmId}`,

  getCropMediaDetail: () => `${getKisaanBaseURL()}/kisaan/crop/detail`,

  getConnectionList: (payload) => {
    const kisanFollowUrl = `${getKisaanBaseURL()}/kisaan/user/${payload?.userId}/${payload?.realmId}/follow/stats`;
    const queryParams = `?offset=${payload?.offset}&count=${payload?.count}&type=${payload?.type}`;
    const targetUserIdParam = payload?.targetUserId ? `&targetUserId=${payload?.targetUserId}` : '';

    return `${kisanFollowUrl}${queryParams}${targetUserIdParam}`;
  },
  autoLogin: () => `${getIamURI()}/api/v2/auth/signin/code`,
  getVideoListAllProfile: (payload) =>
    `${getKisaanBaseURL()}/kisaan/user/${payload?.userId}/videos?offset=${payload?.offset}&count=${payload?.count}`,
  getProfileAllActivity: (payload) =>
    `${getKisaanBaseURL()}/kisaan/user/${payload?.userId}/activity?offset=${payload?.offset}&count=${payload?.count}`,
  getTrueCallerWebData: (requestId) => `${getKisaanBaseURL()}/kisaan/truecaller/p/authenticate/${requestId}`,
};
export default paths;
